<template>
  <vs-row vs-justify="center">
    <vs-col type="flex" vs-justify="center" vs-align="center" vs-sm="12">
      <div class="center grid">
        <vs-row>
          <vs-col class="ps_grid_col" vs-lg="2" vs-sm="2" vs-xs="4" v-bind:key="indextr" v-for="(box, indextr) in newInfoBox">
            <div v-if="box.state == 1">
              <div v-if="box.sub_state==3">
                <vs-button type="border" icon="warning" :to="{ name: 'InfoBox', params: {id: box.id, state: box.state, boxName: box.name} }" class="ps_grid_btn btn_al_1">{{ box.name}}</vs-button>
              </div>
              <div v-else-if="box.sub_state==4">
                <vs-button type="border" icon="warning" :to="{ name: 'InfoBox', params: {id: box.id, state: box.state, boxName: box.name} }" class="ps_grid_btn btn_al_2">{{ box.name}}</vs-button>
              </div>
              <div v-else-if="box.sub_state==5">
                <vs-button type="border" :to="{ name: 'InfoBox', params: {id: box.id, state: box.state, boxName: box.name} }" class="ps_grid_btn btn_nor">{{ box.name}}</vs-button>
              </div>
            </div>
            <div v-if="box.state == 2">
              <vs-button type="border" :to="{ name: 'InfoBox', params: {id: box.id, state: box.state, boxName: box.name} }" class="ps_grid_btn btn_des">
                {{ box.name}}
              </vs-button>
            </div>
            <div v-if="box.state == 3">
              <vs-button type="border" class="ps_grid_btn btn_dis" disabled>
                {{ box.name}}
              </vs-button>
            </div>
          </vs-col>
        </vs-row>
      </div>
    </vs-col>
  </vs-row>
</template>
<script>
export default {
  name: "grid",
  props:{
    newInfoBox: Array
  },
  data() {
    return {
    }
  }
}
</script>
<style>
.btn_al_1{
  /* color: #ffeb3b !important */
  color: #006400 !important
}
.btn_al_1 i{
  color:#ffab6f !important
}
.btn_al_2{
  /* color: #ffab6f !important */
  color: #006400 !important
}
.btn_al_2 i{
  color:#ff4757 !important
}
.btn_nor{
  color: #006400 !important
}
.btn_des{
  color: #ff4757 !important
}
.btn_dis{
  color: #6c757d !important

}
.vs-button:hover{
  color: white !important;
  background-color: white;
  border-color: white;
}
.vs-col.ps_grid_col{
  padding: 0%;
  margin-bottom: 5px;
}
.ps_grid_btn{
  width: 99%;
  padding: 5px;
  border: 3px solid !important;
}
.warning {
    float: right;
    width: auto;
}
.ps_div_alert_grid{
    text-align:center;
  }
.ps_alert_grid{
  width: max-content;
  min-width: 300px;
  margin:0px auto;
}
/* .vs-button--text {
  display: inline;
  font-size: xx-small;
} */
</style>